import { NonEmptyBase, } from '@rimbu/collection-types/set-custom';
import { Stream } from '@rimbu/stream';
import { isEmptyStreamSourceInstance } from '@rimbu/stream/custom';
export class OrderedSetNonEmpty extends NonEmptyBase {
    constructor(context, order, sourceSet) {
        super();
        this.context = context;
        this.order = order;
        this.sourceSet = sourceSet;
    }
    get size() {
        return this.order.length;
    }
    asNormal() {
        return this;
    }
    assumeNonEmpty() {
        return this;
    }
    copy(order = this.order, sourceSet = this.sourceSet) {
        return this.context.createNonEmpty(order, sourceSet);
    }
    stream(options = {}) {
        return this.order.stream(options);
    }
    has(value) {
        return this.sourceSet.has(value);
    }
    add(value) {
        if (this.sourceSet.has(value))
            return this;
        return this.copy(this.order.append(value), this.sourceSet.add(value));
    }
    addAll(values) {
        if (isEmptyStreamSourceInstance(values))
            return this;
        const builder = this.toBuilder();
        builder.addAll(values);
        return builder.build().assumeNonEmpty();
    }
    remove(value) {
        if (!this.context.setContext.isValidValue(value))
            return this;
        const newSet = this.sourceSet.remove(value);
        if (newSet === this.sourceSet)
            return this;
        if (newSet.nonEmpty()) {
            const index = this.order.stream().indexOf(value);
            return this.copy(this.order.remove(index).assumeNonEmpty(), newSet);
        }
        return this.context.empty();
    }
    removeAll(values) {
        if (isEmptyStreamSourceInstance(values))
            return this;
        const builder = this.toBuilder();
        builder.removeAll(values);
        return builder.build();
    }
    forEach(f, options = {}) {
        this.order.forEach(f, options);
    }
    filter(pred, options = {}) {
        const builder = this.context.builder();
        builder.addAll(this.stream().filter(pred, options));
        if (builder.size === this.size)
            return this;
        return builder.build();
    }
    union(other) {
        if (other === this)
            return this;
        if (isEmptyStreamSourceInstance(other))
            return this;
        const builder = this.toBuilder();
        builder.addAll(other);
        return builder.build().assumeNonEmpty();
    }
    difference(other) {
        if (other === this)
            return this.context.empty();
        if (isEmptyStreamSourceInstance(other))
            return this;
        const builder = this.toBuilder();
        builder.removeAll(other);
        return builder.build();
    }
    intersect(other) {
        if (other === this)
            return this;
        if (isEmptyStreamSourceInstance(other))
            return this.context.empty();
        const builder = this.context.builder();
        const otherIter = Stream.from(other)[Symbol.iterator]();
        const done = Symbol('Done');
        let value;
        while (done !== (value = otherIter.fastNext(done))) {
            if (this.has(value))
                builder.add(value);
        }
        if (builder.size === this.size)
            return this;
        return builder.build();
    }
    symDifference(other) {
        if (other === this)
            return this.context.empty();
        if (isEmptyStreamSourceInstance(other))
            return this;
        const builder = this.toBuilder();
        Stream.from(other)
            .filterPure({ pred: builder.remove, negate: true })
            .forEach(builder.add);
        return builder.build();
    }
    toArray() {
        return this.order.toArray();
    }
    toBuilder() {
        return this.context.createBuilder(this);
    }
    toString() {
        return this.stream().join({ start: 'OrderedSet(', sep: ', ', end: ')' });
    }
    toJSON() {
        return {
            dataType: this.context.typeTag,
            value: this.sourceSet.toJSON().value,
        };
    }
}
//# sourceMappingURL=non-empty.mjs.map